import React, { useEffect } from 'react';
import Sidebar from './Sidebar';
import { useLocation } from 'react-router-dom';
import { NAV_MAIN, NAV_QUICK } from './nav';
import LicenseOverlay from '../components/LicenseOverlay';

export default function AppShell({ sidebar, children }) {
  const [open, setOpen] = React.useState(false);
  const { pathname } = useLocation();

  const isAuth = ['/login','/forgot','/reset'].some(p => pathname.startsWith(p));
  const isLanding = pathname === '/';

  const ADMIN=[
    {label:'Settings',to:'/settings'},
    {label:'Logging',to:'/logging'},
    {label:'Users',to:'/users'},
    {label:'Roles',to:'/roles'},
    {label:'Contact Us',to:'/contact'},
    {label:'License',to:'/license'}
  ];
  const drawerRoutes=[...NAV_MAIN,...NAV_QUICK,...ADMIN].map(it=>it.to);
  const isShellRoute=drawerRoutes.some(route=>pathname===route || pathname.startsWith(`${route}/`));
  const hideDrawer = isAuth || isLanding || !isShellRoute;
  const all=[...NAV_MAIN,...NAV_QUICK,...ADMIN];
  function getLabel(path){
    let best=null;
    for(const it of all){
      if(path==='/dashboard' && it.to==='/dashboard') return it.label;
      if(path.startsWith(it.to) && (!best || it.to.length>best.to.length)) best=it;
    }
    return best?best.label:'Menu';
  }
  
  // Mobile-only: aggressively hide legacy topbars/navs outside the drawer
  useEffect(() => {
    if (typeof window !== 'undefined' && window.matchMedia('(max-width: 1024px)').matches) {
      const blacklist = Array.from(document.querySelectorAll('header, nav, [role="navigation"]'));
      blacklist.forEach(el => {
        const txt = (el.textContent || '').toLowerCase();
        const hasNavWords = /(dashboard|customers|products|sales|invoice|credit|reports|pos|returns)/.test(txt);
        const hasBrand = /shopkeeper/.test(txt);
        const isDrawer = !!el.closest('.drawer');
        const isTopbar = el.id === 'topbar';
        if ((hasNavWords || hasBrand) && !isDrawer && !isTopbar) {
          el.setAttribute('data-mobile-hidden', '1');
          (el).style.display = 'none';
        }
      });
    }
  }, []);

  const currentLabel=getLabel(pathname);

  return (
    <div className="sk-shell">
      <button className="btn icon menu-fab" style={{display: hideDrawer ? "none" : undefined}} onClick={()=>setOpen(true)} aria-label="Open menu">☰</button>
      <main className={isAuth ? "sk-content auth-page" : "sk-content"}>{children}</main>
      {!hideDrawer && open && (
        <>
          <div className="drawer-backdrop" onClick={()=>setOpen(false)} />
          <div className="drawer" role="dialog" aria-modal="true" aria-label="Menu">
            <header>
              <div className="title"><span className="dot" /> {currentLabel}</div>
              <button className="close" onClick={()=>setOpen(false)} aria-label="Close">✕</button>
            </header>
            <Sidebar onNavigate={()=>setOpen(false)} />
          </div>
        </>
      )}
      <LicenseOverlay />
    </div>
  );
}
